import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

function initTippy($element) {
	$element.find('.tippyContent').each(function (i, el) {
		tippy(el, {
			theme: 'jenprace',
			zIndex: 10001, // over remodal
			allowHTML: true
		});
	});
}
export default function () {
	$.nette.ext('tippy', {
		init: function () {
			initTippy($(document));

			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initTippy($el);
				}
			});
		}
	});
}
